// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"698":"c6b4365b","5719":"dbd9c535"}[chunkId] + ".chunk.css";
};